module.exports = __webpack_public_path__ + "media/images/logo-clio-ac8b614c1583cd6208afb0002cbe9550.svg";